import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ProductionToolPartService extends Service {
	constructor(injector: Injector) {
		super("ProductionToolPart", injector);
	}

	// API
	forPartId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForPartId/${id}`);
	}

	forProductionToolId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForProductionToolId/${id}`);
	}
}